import { useEffect, useState } from "react";
import { Sparkles, History } from "lucide-react";
import api from "@/lib/api";
import AskPanel from "@/components/AskPanel";

export default function Ask() {
  const [history, setHistory] = useState([]);
  useEffect(() => { api.get("/conversations").then((r) => setHistory(r.data.items)).catch(() => {}); }, []);

  return (
    <div className="space-y-8 max-w-3xl mx-auto">
      <div>
        <h1 className="font-head font-extrabold text-3xl sm:text-4xl flex items-center gap-3"><Sparkles className="w-8 h-8 text-primary" />Ask inizio</h1>
        <p className="text-muted-foreground mt-2">Ask anything practical — learning, money, career, stress, safety, ideas. You'll get a layered answer and a real next step.</p>
      </div>
      <AskPanel />
      {history.length > 0 && (
        <div>
          <h2 className="font-head font-bold text-lg mb-3 flex items-center gap-2"><History className="w-5 h-5 text-muted-foreground" />Recent questions</h2>
          <ul className="space-y-2" data-testid="ask-history">
            {history.slice(0, 8).map((h) => (
              <li key={h.id} className="rounded-md border border-border bg-card px-4 py-2.5 text-sm flex items-center gap-2">
                <span className="text-xs rounded-full bg-secondary px-2 py-0.5 capitalize text-muted-foreground">{h.mode}</span>
                {h.question}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
